import React from 'react'
import { useField } from 'formik'

import { TtFieldset } from '@23/react'

import type { FormikFormControlProps } from './index'

const TtFieldsetFormik = ({
  name,
  invalid,
  errorText,
  ...props
}: FormikFormControlProps<'tt-fieldset'> & {
  name: string
}) => {
  const [field, meta] = useField<never>({
    name,
  })

  return (
    <TtFieldset
      {...props}
      onBlur={field.onBlur}
      invalid={!!meta.error || invalid}
      errorText={meta.error ?? errorText}
    />
  )
}

export { TtFieldsetFormik }
